import { CaretDownIcon } from '@radix-ui/react-icons';
import { Button, DropdownMenu } from '@radix-ui/themes';
import { CubeIcon, CylinderIcon, SphereIcon } from '@phosphor-icons/react';
import type { Icon } from '@phosphor-icons/react';
import { useTranslation, type MessageKey } from '../../../i18n';
import { useEditorStore } from '../../../stores/editorStore';
import type { EditorTool } from '../../../types/editor';

const TOOLS: { id: EditorTool; titleKey: MessageKey; icon: Icon }[] = [
  { id: 'cube3d', titleKey: 'toolbar.tools.cube3d', icon: CubeIcon },
  { id: 'sphere3d', titleKey: 'toolbar.tools.sphere3d', icon: SphereIcon },
  { id: 'box3d', titleKey: 'toolbar.tools.box3d', icon: CubeIcon },
  { id: 'cylinder3d', titleKey: 'toolbar.tools.cylinder3d', icon: CylinderIcon },
  { id: 'prism3d', titleKey: 'toolbar.tools.prism3d', icon: CubeIcon },
  { id: 'mesh3d', titleKey: 'toolbar.tools.mesh3d', icon: CubeIcon },
];

export function ThreeDTools() {
  const { t } = useTranslation();
  const { currentTool, setTool } = useEditorStore();
  const activeTool = TOOLS.find((tool) => tool.id === currentTool);
  const is3DActive = TOOLS.some((tool) => tool.id === currentTool);
  const TriggerIcon = activeTool?.icon ?? CubeIcon;

  return (
    <div className="three-d-tools">
      <DropdownMenu.Root>
        <DropdownMenu.Trigger>
          <Button
            variant="soft"
            radius="none"
            size="3"
            className={`three-d-tools-trigger ${is3DActive ? 'active' : ''}`}
            aria-label={t('toolbar.objects3d')}
          >
            <TriggerIcon aria-hidden="true" weight={is3DActive ? 'fill' : 'regular'} />
            <CaretDownIcon aria-hidden="true" className="three-d-tools-chevron" />
          </Button>
        </DropdownMenu.Trigger>
        <DropdownMenu.Content variant="soft" size="2" align="start" sideOffset={4}>
          {TOOLS.map((tool) => {
            const Icon = tool.icon;
            const isActive = currentTool === tool.id;
            return (
              <DropdownMenu.Item
                key={tool.id}
                onSelect={() => setTool(tool.id)}
                className={isActive ? 'three-d-tools-item-active' : undefined}
              >
                <Icon aria-hidden="true" weight={isActive ? 'fill' : 'regular'} />
                {t(tool.titleKey)}
              </DropdownMenu.Item>
            );
          })}
        </DropdownMenu.Content>
      </DropdownMenu.Root>
    </div>
  );
}
